import { render, staticRenderFns } from "./DuplicatesItems.vue?vue&type=template&id=e88374c6&"
import script from "./DuplicatesItems.vue?vue&type=script&lang=js&"
export * from "./DuplicatesItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports